module.exports = __webpack_public_path__ + "static/media/star1.025a49fa.svg";